<template>
	<div class="order-view">
		<nav-bar>订单详情</nav-bar>
		<div v-if="record" class="box" :class="{ 'hidden': !pageVisible, 'top': visibility.orderResult || visibility.orderResultClose }">
			<db-notice v-if="visibility.notice" @refresh="onClickRefreshBtn">
				如遇支付成功后出现待支付状态，请刷新后查看
			</db-notice>
			<pay-order-card v-if="visibility.payOrderCard" :data-source="record"/>
			<order-result v-if="visibility.orderResult"/>
      <!-- getOrderAim自定义状态、订单状态、跳转页面看不懂，所以不在原基础上改，自己加个状态吧。。。 -->
			<order-result-close v-if="visibility.orderResultClose"/>
			<order-summary v-if="visibility.orderSummary" :data-source="record"/>
			<div class="bottom" v-if="visibility.bottom">
				<div class="tip">请在5分钟内完成支付，超时订单自动取消</div>
				<div class="row">
					<VanButton class="button cancel-button" @click="onClickCancel">{{canceling? '正在取消' : '取消订单'}}</VanButton>
					<VanButton class="button pay-button" :disabled="payButtonDisabled" @click="onClickPayBtn">{{isServiceManager ? '立即下单' : '立即支付'}}</VanButton>
				</div>
			</div>
			<div class="back" v-if="visibility.orderResult || visibility.orderResultClose">
					<VanButton class="button back-button" @click="onClickBackBtn">返回首页</VanButton>
			</div>
      <div id="alipay"></div>
		</div>
	</div>
</template>
<script>
import NavBar from "../../components/nav-bar/index";
import DbNotice from "../../components/notice/index";
import OrderSummary from "./components/order-summary";
import OrderResult from "./components/order-result";
import OrderResultClose from "./components/order-result-close";
import {mapGetters} from 'vuex';
import PayOrderCard from "./components/pay-order-card";
import {wait, isWX, isAlipay, isMiniprogram, isKuaiQian} from "../../utils";

let toast;
export default {
	name: 'Order',
	components: {PayOrderCard, OrderResult, OrderSummary, DbNotice, NavBar, OrderResultClose},
	data() {
		return {
			paying: false,
			record: null,
			loading: false,
			canceling: false,
			timer: null,
			pageVisible: true
		};
	},
	computed: {
		...mapGetters({
			aim: 'order/aim',
			orderInfo: 'order/orderInfo'
		}),
		ticketInfoId() {
			let {id} = this.record || {};
			return this.$route.query.ticketInfoId || id;
		},
		wxPayInfo() {
			return this.$AppService.getWxPayInfo();
		},
		isAimPay() {
			return this.$OrderService.getOrderAim() === 'pay';
		},
		isAimState() {
			return this.$OrderService.getOrderAim() === 'state';
		},
		isAimInfo() {
			return this.$OrderService.getOrderAim() === 'info';
		},
		isStateNotPay() {
			const {isStatusNotPay} = this.record || {};
			return isStatusNotPay;
		},
		isStatusRefunding() {
			const {isStatusRefunding, isStatusSysRefunding} = this.record || {};
			return isStatusRefunding || isStatusSysRefunding;
		},
    isStatusClosed() {
			const {isStatusClosed} = this.record || {};
			return isStatusClosed;
		},
		visibility() {
			return {
				notice: this.isAimState && this.isStateNotPay,
				payOrderCard: this.isAimPay || (this.isAimState && !this.isStatusRefunding),
				orderResult: this.isAimState && this.isStatusRefunding,
        orderResultClose: this.isAimInfo && this.isStatusClosed,
				orderSummary: this.isAimInfo || (this.isAimState && this.isStatusRefunding),
				bottom: this.isAimPay || (this.isAimState && this.isStateNotPay)
			};
		},
		payButtonDisabled() {
			return this.paying;
		},
		isServiceManager() {
			return this.$UserService.isServiceManager();
		}
	},
	watch: {
		orderInfo: {
			immediate: true,
			deep: true,
			handler(orderInfo) {
				if (orderInfo) {
					this.paying = false;
					this.loading = false;
				}
			}
		},
		paying(paying) {
			this.showToast('支付中，请稍候', paying);
		},
		loading(loading) {
			this.showToast('加载中...', loading);
		},
		timer(timer) {
			if (!timer) {
				toast.hide();
			}
		}
	},
	activated() {
		this.loading = true;
		this.$nextTick(() => {
			if (this.ticketInfoId) {
				this.$AppService.setTicketInfoId(this.ticketInfoId);
			}
			this.refresh();
			this.$OrderService.startLooping();
		});
	},
	beforeRouteEnter (to, from, next) {
		console.log('to', from, to)
		next(vm => {
			vm.pageVisible = false
			setTimeout(() => {
				vm.pageVisible = true
			}, 300)
		})
	},
	beforeRouteLeave(to, from, next) {
		this.loading = false;
		this.paying = false;
		this.$OrderService.stopLooping();
		if (this.timer) {
			if (toast) {
				toast.hide();
			}
			clearTimeout(this.timer);
			this.timer = null;
		}
		next();
	},
	methods: {
		refresh() {
			this.loading = true;
			this.$OrderService.getOrderInfo(this.ticketInfoId).then((res) => {
        console.log('getOrderInfo res: ', res)
				const ticketPriceDetail = res.ticketPriceDetail ? JSON.parse(res.ticketPriceDetail): []
				this.record = Object.assign({}, res, {ticketPriceDetail});
				this.$forceUpdate();
				this.loading = false;
				this.paying = false;
			}).catch((res) => {
				this.$toast(res.msg || res);
				this.loading = false;
				this.paying = false;
			});
		},
		onClickRefreshBtn() {
			this.loading = true;
			this.refresh();
		},
		onClickPayBtn() {
      const {baseLineId} = this.orderInfo || {}
      const supportAreaIds = this.$UserService.getSupportAreaIds() || []
			if (this.isServiceManager && supportAreaIds.includes(baseLineId)) {
				this.$OrderService.setOrderAimState();
				return;
			}
			
			this.paying = true;
			// 小程序支付
			if (isMiniprogram()) {
				this.$AppService.mppay(this.orderInfo)
				this.paying = false
				return
			}
			this.fetchWxPayInfo().then(wxPayInfo => {
				// 快钱支付
				if (isKuaiQian(this.$AppService.getCityId())) {
					this.$AppService.kqPay(wxPayInfo);
				} else if (isWX()) {
					// 公众号支付
          this.$AppService.pay(JSON.parse(wxPayInfo)).then((res) => {
            console.log('支付res', res);
            this.$OrderService.setOrderAimState();
            this.loading = true;
          }).catch((err) => {
            console.log('支付catch', err);
            this.$OrderService.setOrderAimState();
            this.loading = true;
            this.timer = setTimeout(() => {
              console.log('等待了10秒');
              clearTimeout(this.timer);
              this.timer = null;
            }, 10000);
          });
        } else if (isAlipay()) {
          this.$AppService.alipay(wxPayInfo)
        } else {
          // h5支付
          try {
            window.location.href = wxPayInfo
          } catch(e) {
				    this.$toast(e && e.msg ? e.msg : '支付失败' );
          }
        }
			}).catch(res => {
				console.log(res);
				this.$toast(res.msg);
			});
		},
		onClickBackBtn() {
			this.$HomeService.redirectToHomeView();
		},
		fetchWxPayInfo() {
			return this.$AppService.fetchWxPayInfo(this.ticketInfoId);
		},
		onClickCancel() {
			if (this.canceling) {
				return;
			}
      let guard = this.$dialog.confirm({
        content: '确认取消订单吗？',
        confirmText: '确认',
        onOk: () => {
          this.canceling = true;
          this.$OrderService.cancelOrder(this.ticketInfoId).then(() => {
            this.$toast({
              message: '取消成功',
              duration: 2000
            });
            wait(2000).then(() => {
              this.canceling = false;
              this.$router.back();
            });
          }).catch((e) => {
            this.$cheToast({
              type: 'fail',
              text: e.msg
            });
            this.canceling = false;
          });
        }
      });
      guard.show();
		},
		showToast(text, visible) {
			if (this.timer) {
				text = '正在等待支付结果，请稍候';
			}
			toast = this.$createToast({
				type: 'loading',
				text
			});
			if (visible || !!this.timer) {
				toast.show();
			} else {
				toast.hide();
			}
		},
	}
}
</script>

<style scoped lang="scss">
	@import "../../assets/style/common.scss";
	.order-view {
		background: #f7f7f7;
		min-height: 100vh;
		z-index: 100;
		font-size: 12px;
		padding-bottom: 90px;
		opacity: 1;
		.box {
			padding: 10px;
		}
		.top {
			padding-top: 0px;
		}
		.bottom {
			position: fixed;
			bottom: 0;
			left: 0;
			right: 0;
			background: #ffffff;
		}
		.tip {
			position: absolute;
			top: -35px;
			left: 0;
			right: 0;
			height: 60px;
			background: #E1EEFF;
			border-radius: 28px 28px 0px 0px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 12px;
			color: #7C818E;
			line-height: 16px;
			text-align: left;
			font-style: normal;
			z-index: 1;
			text-align: center;
			padding-top: 12px;
		}
		.row {
			position: relative;
			z-index: 10;
			display: flex;
			align-items: center;
			padding: 12px 20px 0 20px;
			padding-bottom: calc(20px + constant(safe-area-inset-bottom));
			padding-bottom: calc(20px + env(safe-area-inset-bottom));
			box-shadow: 0px -2px 8px 0px #D7E3EA;
			border-radius: 28px 28px 0px 0px;
			background: #ffffff;
		}
		.button {
			flex: 1;
			border-radius: 25px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 500;
			font-size: 16px;
			line-height: 22px;
			text-align: center;
			font-style: normal;
		}

		.pay-button {
			background: linear-gradient( 90deg, #00A7FD 0%, #006EFA 100%);
			color: #ffffff;
		}
		.cancel-button {
			background: #ECEFF3;
			color: #999999;
			margin-right: 10px;
		}
		.back {
			position: fixed;
			bottom: 0;
			left: 0;
			right: 0;
			padding: 10px;
			padding-bottom: calc(20px + constant(safe-area-inset-bottom));
			padding-bottom: calc(20px + env(safe-area-inset-bottom));
			background: #F3F4F5;
			display: flex;
		}
		.back-button {
			height: 48px;
			background: linear-gradient( 90deg, #00A7FD 0%, #006EFA 100%);
			color: #ffffff;
		}
		.hidden {
			opacity: 0;
		}
	}
  #alipay {
    opacity: 0;
    position: absolute;
    left: -2000px;
  }
</style>
